import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-directory-search-channels',
  templateUrl: './directory-search-channels.component.html',
  styleUrls: ['./directory-search-channels.component.scss'],
})
export class DirectorySearchChannelsComponent
{
  @Input() public allowSelection = false;
  @Input() public singleSelectionOnly = false;
  @Input() public disableEscape = false;
  @Input() public doNotResetScrollOnClose = false;
  @Input() public allowFacilitySearch = true;
  @Input() public memberId: number;

  @Output() public closing = new EventEmitter();
  @Output() public selectProvider = new EventEmitter();

  public windowState = 'maximized';
  public dialogSearchDirectoryOpened = false;
  public selectedProviders: number[] = [];

  @Input() public set dialogOpened(value: boolean)
  {
    if (value)
    {
      this.selectedProviders = [];
      this.dialogSearchDirectoryOpened = true;
      document.body.style.overflow = 'hidden';
    }
  }

  /**
   * Closing the provider search.
   *
   * @param emitClose True when called from the html page. This would send a close emit event.
   */
  public closeSearch(emitClose: boolean): void
  {
    // Close dialog
    if (!this.doNotResetScrollOnClose)
    {
      document.body.style.overflow = '';
    }
    this.dialogSearchDirectoryOpened = false;
    if (emitClose)
    {
      this.closing.emit();
    }
  }

  /**
   * This event handle disabled the ESC keyboard key of the directory search.
   *
   * @param e Event
   */
  public modalKeyDown(event: KeyboardEvent): void
  {
    if (event && event.key === 'Escape' && !this.disableEscape)
    {
      event.preventDefault();
    }
  }

  public onSetProviders(e: any): void
  {
    this.selectedProviders = e;
  }

  /**
   * Method called when the select button have been hit.
   * The method construct a selected array that will contains the list of selected providers.
   */
  public onSelectedProviders(): void
  {
    // Should have some selected
    if (this.selectedProviders.length > 0)
    {
      this.selectProvider.emit(this.selectedProviders);
      this.closeSearch(false);
    }
  }

  /**
   * Provides the providers selected count. This controls the 'Select' button state and count display.
   *
   * @returns Number Total count of the selected providers.
   */
  public getSelectedCount(): number
  {
    return this.selectedProviders.length;
  }
}
